import { put } from "redux-saga/effects";

export function* successToast({ message }) {
  yield put({ type: "SET_SUCCESS", success: message });
}
